(function() {
  function init() {
    const buttons = document.querySelectorAll('.bd-customer-trust__button');
    
    buttons.forEach(button => {
      button.addEventListener('click', function() {
        const target = document.querySelector('.jdgm-rev-widg');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
